import { render, staticRenderFns } from "./widgetPrevTrans.vue?vue&type=template&id=a3edaae6&scoped=true&"
import script from "./widgetPrevTrans.vue?vue&type=script&lang=js&"
export * from "./widgetPrevTrans.vue?vue&type=script&lang=js&"
import style0 from "./widgetPrevTrans.vue?vue&type=style&index=0&id=a3edaae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3edaae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
